import React, { FC } from "react";
import Button from "../../button";

const PaymentFooter: FC<{ confirm: () => void }> = ({ confirm }) => (
  <>
    <div className="row">
      <div className="col-12 text-center">
        <Button className="w-100 confirm-and-pay" onClick={confirm}>
          Confirm and Pay
        </Button>
      </div>
    </div>
    <div className="payment-text">
      We do not store your credit card information in our system at any point in
      time. Your payment information is securely transmitted to Stripe. If you
      have any questions, please don't hesitate to contact us at
      billing@hexact.io
    </div>
  </>
);

export default PaymentFooter;
